import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";

import './App.css';
import Inicio from './components/Inicio';

function AppContent() {
  console.log("🚀 [AppContent] Renderizando rutas de la aplicación...");

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Inicio initialPage={0} />} />
        <Route path="/inicio" element={<Inicio initialPage={0} />} />
        <Route path="/provincia" element={<Inicio initialPage={1} />} />
        <Route path="/juanamanso" element={<Inicio initialPage={2} />} />
        <Route path="/aprender" element={<Inicio initialPage={3} />} />
        <Route path="/nacion" element={<Inicio initialPage={4} />} />
        <Route path="/descargas" element={<Inicio initialPage={5} />} />
        <Route path="/desbloqueos" element={<Navigate to="/juanamanso" replace />} />
        <Route path="/desbloqueos/:slug" element={<Inicio />} />
        <Route path="*" element={<h1>No existe la página</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <div className="App">
        <AppContent />
      </div>
    </MsalProvider>
  );
}